module.exports = __webpack_public_path__ + "img/gulasch.01e5141c.png";